import { render, staticRenderFns } from "./DistributionChart.vue?vue&type=template&id=b4a5a7e2&"
import script from "./DistributionChart.vue?vue&type=script&lang=js&"
export * from "./DistributionChart.vue?vue&type=script&lang=js&"
import style0 from "./DistributionChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports